import React, { useMemo, useCallback, useReducer } from 'react'

import { actions, designReducer } from './reducer'
import { DesignContext } from './context'

import communities from '../data/communities.json'

export const SAVED_DESIGN_ID_KEY = 'current_design_id'
export const SAVED_DESIGN_KEY = 'design'
export const UNSAVED_DESIGN_KEY = `${SAVED_DESIGN_KEY}__NEW`

function getStorageKey (boardId) {
  if (!boardId) {
    return UNSAVED_DESIGN_KEY
  }
  return `${SAVED_DESIGN_KEY}__${boardId}`
}

const INITIAL_STATE = {
  config: { communities, disclaimer: 'DISCLAIMER' },
  community: { id: '', title: '', logoUrl: '' },
  lot: { label: '' },
  externalLabel: '',
  // isCollection: false, // don't keep in state since it doesn't change
  currentBoardIndex: 0,
  currentSlotSelection: null,
  boards: [
    { label: 'Kitchen', items: [] },
    { label: 'Owner\'s Bath', items: [] },
    { label: 'Bath 2 / Bath 3', items: [] },
  ]
}
export const EMPTY_STATE = INITIAL_STATE

const DesignProvider = ({ children }) => {
  // console.log('DesignProvider()')
  const [ state, dispatch ] = useReducer(designReducer, INITIAL_STATE)

  const getCurrentBoard = useCallback(() => {
    return state.boards[ state.currentBoardIndex ]
  }, [ state ])

  const contextValue = useMemo(() => {
    return { state, getCurrentBoard, dispatch }
  }, [ state, getCurrentBoard, dispatch ])

  return (
    <DesignContext.Provider value={contextValue}>
      {children}
    </DesignContext.Provider>
  )
}

// DesignProvider.whyDidYouRender = true

export {
  getStorageKey,
  actions,
  designReducer,
  DesignContext,
  DesignProvider
}